import axios from "axios";
import WriteToLog from "./WriteToLog";

/**
 * Get Observation.Search (Vitals) (R4) data from EHR
 * @param {*} patID 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getObservationVitalsWeightWithin7Days(patFHIRID, fhir_server, access_token) {
  var category = "vital-signs";
  //var code = "14"; // FLO is 14 for Weight
  let errorCode = "";
  const vitals = {};

  var date = new Date();
  //console.log("date now: " + date);
  date.setHours(date.getHours() - 168);
  //console.log("date - 168 hours (7 days): " + date);
  const isoStringWithoutMs = date.toISOString().slice(0, 19) + 'Z';
  //console.log(isoStringWithoutMs);

  var date2 = new Date();
  date2.setHours(date2.getHours() - 1);
  //console.log("date - 1 hour: " + date2);
  const isoStringWithoutMs2 = date2.toISOString().slice(0, 19) + 'Z';
  //console.log(isoStringWithoutMs2);

  const ehrconfig = await axios.get('ehrconfig.json');
  let observationSearchUrl = ehrconfig.data["EHR_OBSERVATION_SEARCH_R4"];
  let getObservationVitalsUrl = fhir_server + observationSearchUrl + '?category=' + category + '&patient=' + patFHIRID + '&date=ge' + isoStringWithoutMs + '&date=le' + isoStringWithoutMs2;

  try {
    let response = await axios.get(
      getObservationVitalsUrl,
      {
        headers:
        {
          'Authorization': 'Bearer ' + access_token,
          'Accept': 'application/json'
        }
      });
    //WriteToLog("getObservationVitalsWeightWithin7Days Observation.Search (R4) FHIR response: " + JSON.stringify(response.data));
    if (response.data.total > 0) {
      let entryArray = response.data.entry;
      for (var i= 0; i < entryArray.length; i++) {
        if (entryArray[i].resource !== undefined) {
          let resourceType = entryArray[i].resource.resourceType;
          if (resourceType === "Observation" && entryArray[i].resource.code !== undefined) {
            let code = entryArray[i].resource.code.text;
            if (code === "Weight") {
              //console.log("issued: " + entryArray[i].resource.issued);
              if (entryArray[i].resource.valueQuantity !== undefined) {
                const floValue = {};
                floValue.value = entryArray[i].resource.valueQuantity.value;
                floValue.unit = entryArray[i].resource.valueQuantity.unit;
                floValue.timestamp = entryArray[i].resource.issued;
                //console.log("floValue: " + JSON.stringify(floValue));
                // Get the latest value from the top
                if(vitals[code] === undefined ) {
                  vitals[code] = floValue;
                }
              }
            } 
          }
        }
      }
      return vitals.Weight;
    } else {
      //ehr value empty if total is 0
      let entryArray = response.data.entry;
      for (var j = 0; j < entryArray.length; j++) {
        if (entryArray[j].resource !== undefined) {
          let resourceType = entryArray[j].resource.resourceType;
          if (resourceType === "OperationOutcome" && entryArray[j].resource.issue !== undefined) {
            let issueArray = entryArray[j].resource.issue;
            if (issueArray.length > 0) {
              if (entryArray[j].resource.issue[0].diagnostics !== undefined)
              {
                errorCode = "Error: " + entryArray[j].resource.issue[0].diagnostics;
              } else {
                errorCode = entryArray[j].resource.issue[0].details.text;
              }
            }
          }
        }
      }
      return errorCode;
    }
  } catch (error) {
    WriteToLog("getObservationVitalsWeightWithin7Days Observation.Search FHIR error: " + error.message);
    return null;
  }
}

export default getObservationVitalsWeightWithin7Days;
